import { FileText, DollarSign, Scale, Shield, Building2, Bell, Home as HomeIcon, Package, Flame, BookOpen, CheckCircle, Download } from 'lucide-react';

// Quick access categories for top banner (like LegalZoom)
export const quickCategories = [
  {
    name: 'Credit Disputes',
    icon: DollarSign,
    slug: 'credit-disputes',
  },
  {
    name: 'Business Credit',
    icon: Building2,
    slug: 'business-credit',
  },
  {
    name: 'Court Motions',
    icon: Scale,
    slug: 'court-motions',
  },
  {
    name: 'Affidavits',
    icon: FileText,
    slug: 'affidavits',
  },
  {
    name: 'Trust & Estate',
    icon: Shield,
    slug: 'trust-estate',
  },
  {
    name: 'Legal Notices',
    icon: Bell,
    slug: 'legal-notices',
  },
  {
    name: 'Landlord-Tenant',
    icon: HomeIcon,
    slug: 'landlord-tenant',
  },
  {
    name: 'Bundles',
    icon: Package,
    slug: null,
    href: '/shop',
  },
  {
    name: 'Civil Lawsuit Templates & Filing Guide',
    icon: Flame,
    badge: 'NEW',
    emoji: '🔥',
    slug: 'lawsuits',
  },
];

// Main categories for the grid section
export const mainCategories = [
  {
    name: 'Credit Disputes',
    icon: DollarSign,
    description: 'Credit report disputes, collection disputes, identity theft, and credit bureau procedures.',
    guideCount: '20',
    slug: 'credit-disputes',
  },
  {
    name: 'Business Credit',
    icon: Building2,
    description: 'Business credit setup, vendor trade lines, corporate credit funding, and compliance.',
    guideCount: '20',
    slug: 'business-credit',
  },
  {
    name: 'Court Motions',
    icon: Scale,
    description: 'Civil motions, discovery motions, trial motions, and post-judgment procedures.',
    guideCount: '20',
    slug: 'court-motions',
  },
  {
    name: 'Affidavits',
    icon: FileText,
    description: 'Personal, identity, legal process, financial, and estate affidavits.',
    guideCount: '20',
    slug: 'affidavits',
  },
  {
    name: 'Trust & Estate',
    icon: Shield,
    description: 'Trust formation, estate planning, asset protection, and estate documentation.',
    guideCount: '20',
    slug: 'trust-estate',
  },
  {
    name: 'Legal Notices',
    icon: Bell,
    description: 'Demand letters, cease & desist, legal disputes, and administrative notices.',
    guideCount: '20',
    slug: 'legal-notices',
  },
  {
    name: 'Landlord-Tenant',
    icon: HomeIcon,
    description: 'Tenant notices, landlord notices, lease enforcement, and rental disputes.',
    guideCount: '20',
    slug: 'landlord-tenant',
  },
  {
    name: 'Civil Lawsuit Templates & Filing Guide',
    icon: Flame,
    description: 'Real-world lawsuit templates with line-numbered complaints, statutory citations, case law exhibits, and prayer for relief.',
    guideCount: '7',
    slug: 'lawsuits',
    badge: 'NEW',
  },
];

export const mockFeatures = [
  {
    icon: BookOpen,
    title: 'Structured Guides',
    description: 'Every guide includes step-by-step explanations, breaking down complex legal processes into easy-to-understand instructions.',
  },
  {
    icon: FileText,
    title: 'Sample Templates',
    description: 'Access professionally formatted templates and reference materials that you can adapt for your specific situation.',
  },
  {
    icon: CheckCircle,
    title: 'Real-World Examples',
    description: 'Learn from actual documentation processes used in real-world legal and administrative situations.',
  },
  {
    icon: Download,
    title: 'Instant Access',
    description: 'Download guides immediately after purchase. All materials are available in easy-to-read digital formats.',
  },
  {
    icon: Shield,
    title: 'Comprehensive Coverage',
    description: 'From credit disputes to court motions, we cover the most commonly used legal and administrative documents.',
  },
  {
    icon: Package,
    title: 'Bundle Savings',
    description: 'Save more with our curated bundles. Get multiple related guides at discounted prices.',
  },
];

export const mockStats = [
  {
    value: '147+',
    label: 'Documentation Guides',
  },
  {
    value: '8',
    label: 'Main Categories',
  },
  {
    value: '5,000+',
    label: 'Happy Customers',
  },
  {
    value: '24/7',
    label: 'Instant Access',
  },
];

export const mockGuides = [
  {
    id: 1,
    title: '609 Credit Dispute Letter',
    category: 'Credit Disputes',
    description: 'Complete guide to writing effective 609 credit dispute letters with sample templates.',
    price: 29.99,
    pages: 15,
    rating: 4.8,
  },
  {
    id: 2,
    title: 'Motion to Dismiss',
    category: 'Court Motions',
    description: 'Step-by-step instructions for preparing and filing a Motion to Dismiss.',
    price: 34.99,
    pages: 22,
    rating: 4.9,
  },
  {
    id: 3,
    title: 'Revocable Living Trust',
    category: 'Trust & Estate',
    description: 'Comprehensive guide to setting up a revocable living trust with all necessary documentation.',
    price: 49.99,
    pages: 35,
    rating: 4.7,
  },
  {
    id: 4,
    title: 'Business Credit Setup',
    category: 'Business Credit',
    description: 'Complete roadmap for establishing and building business credit from scratch.',
    price: 39.99,
    pages: 28,
    rating: 4.8,
  },
];

export const mockTestimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Small Business Owner',
    content: 'The business credit guides saved me thousands in consultant fees. Clear, detailed, and actually works!',
    rating: 5,
  },
  {
    name: 'Michael Chen',
    role: 'Real Estate Investor',
    content: 'Best investment I made. The landlord-tenant guides have helped me handle every rental situation professionally.',
    rating: 5,
  },
  {
    name: 'Emily Rodriguez',
    role: 'Paralegal',
    content: 'I recommend PaperworkDepot to all my clients. The court motion guides are incredibly thorough and accurate.',
    rating: 5,
  },
];